
    import '/home/ec2-user/Youlify-Design/components/result/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["result-demo-success","result-demo-info","result-demo-warning","result-demo-403","result-demo-404","result-demo-500","result-demo-error","result-demo-customicon","result-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/result/index.zh-CN.md?type=demo')
};